module.exports = __webpack_public_path__ + "assets/shopify-logo.54ac8931.svg";